"use client"
import React from "react"
import Navbar from "../../components/agent/common/Navbar"
import CampaignCreate from "../../components/agent/marketing/CampaignCreate"

const AgentMarketingCampaignCreate = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
        <CampaignCreate />
      </main>
    </div>
  )
}

export default AgentMarketingCampaignCreate